module.exports = __webpack_public_path__ + "static/media/Logo.e82dbc2f.png";